import React from 'react';
import { useParams } from 'react-router-dom';

import { ModeContextProvider } from '../../../../contexts';
import { PAGE_COMMON_TEXT } from '../lang';
import { waitingForProcessing } from '../WaitProcess';
import {
  useGetQualificationCheck,
  QualificationCheckForm,
  QualificationDetailMode,
} from '../../../AcademicRegistry';
import { Loading, Alert, Accordion } from '../../../../components';

export const QualificationCheckView: React.FunctionComponent = () => {
  const { applicationId } = useParams();

  const { qualificationCheck, application, applicantBasic, loading, error } =
    useGetQualificationCheck(applicationId as string);

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }
  const hasQualificationCheck =
    qualificationCheck !== undefined && qualificationCheck !== null;

  return (
    <>
      {loading ? (
        <Loading />
      ) : hasQualificationCheck ? (
        <Accordion
          title={PAGE_COMMON_TEXT.SIDEBAR_TEXT.QUALIFICATION_CHECK}
          defaultExpanded
          details={
            <ModeContextProvider mode={QualificationDetailMode.MONITOR_VIEW}>
              <QualificationCheckForm
                applicantBasic={applicantBasic}
                application={application}
                qualificationCheck={qualificationCheck}
              />
            </ModeContextProvider>
          }
        />
      ) : (
        waitingForProcessing(PAGE_COMMON_TEXT.SIDEBAR_TEXT.QUALIFICATION_CHECK)
      )}
    </>
  );
};
